<template>
  <div>
    <div class="topbar">
      <div class="clearfix main-wrap">
        <a class="pull-left img-back" href="javascript:window.history.go(-1)">返回</a>
        <h1>电子保单</h1>
      </div>
      <div class="liner"></div>
    </div>



    <div class="main-page" style="padding-bottom:0">
      <div id="myIframe">
      </div>
    </div>
  </div>
</template>
<style scoped>
  .pdf{width:100vw;height:100vh;}
</style>
<script>
export default {
  data () {
    return {
      pdfUrl: ''
    }
  },
  mounted: function () {
    this.pdfUrl = this.$route.params.pdfUrl
    $('#myIframe').html('<iframe id="myIframe" width="100%" frameborder="0" height="' + $(window).height() + '" src="http://' + this.pdfUrl + '"></iframe>')
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// InsurancePdf.vue?93f2cb80